import 'dayjs/locale/fr-ca'

import type React from 'react'
import { Suspense, useMemo } from 'react'

import { useParams, useSearch } from '@tanstack/react-router'
import dayjs from 'dayjs'

import { ChannelView } from '@/components/templates/ChannelView'

import { useEveningChannelPage } from './useEveningChannelPage.ts'
import { useReadOnlyMessagingRail } from './useMessagingRail.ts'

const EveningChannelPageContent: React.FC = () => {
  const { eveningId, channelId } = useParams({ from: '/regions/messages/$eveningId/channels/$channelId' })
  const search = useSearch({ from: '/regions/messages/$eveningId/channels/$channelId' })

  const railSearch = useMemo(
    () => ({
      regionName: search.regionName,
      piloteRegionId: search.piloteRegionId,
      eveningDate: search.eveningDate,
      regionId: search.regionId,
    }),
    [search.regionName, search.piloteRegionId, search.eveningDate, search.regionId]
  )

  const rail = useReadOnlyMessagingRail({
    destination: 'channel',
    channelId,
    teamsTo: '/regions/messages/$eveningId',
    teamsParams: { eveningId },
    channelTo: '/regions/messages/$eveningId/channels/$channelId',
    channelParams: { eveningId, channelId },
    search: railSearch,
  })

  const props = useEveningChannelPage({
    eveningId: Number(eveningId),
    channelId,
    regionId: search.regionId,
    regionName: search.regionName ?? '',
    piloteRegionId: search.piloteRegionId ?? 0,
    rail,
  })

  const formattedDate = search.eveningDate
    ? dayjs(search.eveningDate).locale('fr-ca').format('dddd D MMMM YYYY')
    : undefined

  return <ChannelView {...props} readOnlyDate={formattedDate} />
}

export const EveningChannelPage: React.FC = () => (
  <Suspense
    fallback={<div className="flex h-screen items-center justify-center bg-gray-800 text-white">Loading...</div>}>
    <EveningChannelPageContent />
  </Suspense>
)
